"use client";

import React, { useEffect, useState } from "react";
import { ControllerRenderProps, FieldPath, FieldValues } from "react-hook-form";
import { cn } from "@/lib/utils";

type Props<
  TFieldValues extends FieldValues,
  TFieldName extends FieldPath<TFieldValues>,
> = {
  label?: string;
  icon?: React.ReactNode;
  error?: string;
  iconClass?: string;
  "data-sentry-unmask"?: boolean;
} & ControllerRenderProps<TFieldValues, TFieldName>;

export function TextAreaFormField<
  TFieldValues extends FieldValues,
  TFieldName extends FieldPath<TFieldValues>,
>(props: Props<TFieldValues, TFieldName>) {
  const [ref, setRef] = useState<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    if (ref) {
      ref.style.height = "inherit";
      ref.style.height = `${ref.scrollHeight}px`;
    }
  }, [ref]);

  return (
    <div className="form-group">
      <div
        className={cn("input-group flex min-h-8", props.disabled && "disabled")}
      >
        {props.label && <label htmlFor={props.name}>{props.label}</label>}
        {props.icon && <span className="h-4 w-4 p-1">{props.icon}</span>}
        <textarea
          {...props}
          data-sentry-unmask={props["data-sentry-unmask"]}
          id={props.name}
          ref={(node) => {
            setRef(node);
            props.ref(node);
          }}
          rows={1}
          className="mb-0"
        />
      </div>
      <span className="form-error">{props.error}</span>
    </div>
  );
}
